<template>
  
<div class="boxItemBody">
    <template v-for="(box, index) in boxgroups">
        <div :key="index" class="boxItem">
            <div class="row">
                <div class="col-md-4">
                    <div class="itemImage">
                        <template v-for="flavor in box.flavors">
                            <img :key="flavor.id+`${Math.random()}`" :src="flavor.side_image_url" :alt="flavor.name">
                        </template>

                    </div>
                </div>

                <div class="col-md-8">
                    <div class="boxItemDescription">
                        <h1>{{box.count > 1 ? `(${box.count}) Dozen of` : ''}} {{box.box_name}}</h1>

                        <p>{{box.flavorsname.map(f => f.name).join(', ')}}</p>
                    </div>
                </div>
            </div>
        </div>
    </template>

   
</div>
</template>

<script>


/**
 * Mixins
 */
import {orderboxmixins} from '@/mixins/orderboxmixins'

export default {
    mixins  : [orderboxmixins],
    props : {
        orderboxes : {
            type : Array,
            default : () => {
                return []
            }
        }
    },
    data() {
        return  {
            boxgroups : []
        }
    },
    watch : {
        /**
         * re-group order boxes if there's changes on the list
         */
        orderboxes : {
            handler() {
                // Orderbox grouping
                this.boxgrouping();
            },
            deep : true
        }
    },
    methods : {
        /**
         * Group box order with same box type and flavors
         */
        boxgrouping() {
            this.boxgroups = this.groupboxorder(this.orderboxes);
        }
    },
    /**
     * Run function after component rendered
     */
    mounted() {
        // Orderbox grouping
        this.boxgrouping();
    }
    
}
</script>

<style>

</style>